'use strict';

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _containers = require('containers');

exports['default'] = function () {
  return _react2['default'].createElement(
    _reactRouter.Route,
    { path: '/', component: _containers.App },
    _react2['default'].createElement(_reactRouter.IndexRoute, { component: _containers.Home, name: 'index' }),
    _react2['default'].createElement(_reactRouter.Route, { path: '/:categoryId', component: _containers.Home, name: 'category' }),
    _react2['default'].createElement(_reactRouter.Route, { path: '/guides/:postId', component: _containers.Post, name: 'post' }),
    _react2['default'].createElement(_reactRouter.Route, { path: '/industry/:postId', component: _containers.Post, name: 'post' }),
    _react2['default'].createElement(_reactRouter.Route, { path: '/insights/:postId', component: _containers.Post, name: 'post' }),
    _react2['default'].createElement(_reactRouter.Route, { path: '/news/:postId', component: _containers.Post, name: 'post' }),
    _react2['default'].createElement(_reactRouter.Route, { path: '/use-cases/:postId', component: _containers.Post, name: 'post' }),
    _react2['default'].createElement(_reactRouter.Route, { path: '*', component: _containers.NotFound, status: 404, name: 'not-found' })
  );
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/routes.js
// module id = 684
// module chunks = 0